/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Microsoft_Calendar_Read_ErrorInputs */

const es_tools_microsoft_calendar_read_error = /** @type {(inputs: Tools_Microsoft_Calendar_Read_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al leer evento de Microsoft`)
};

const en_tools_microsoft_calendar_read_error = /** @type {(inputs: Tools_Microsoft_Calendar_Read_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error reading Microsoft event`)
};

/**
* | output |
* | --- |
* | "Error reading Microsoft event" |
*
* @param {Tools_Microsoft_Calendar_Read_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_microsoft_calendar_read_error = /** @type {((inputs?: Tools_Microsoft_Calendar_Read_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Microsoft_Calendar_Read_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_microsoft_calendar_read_error(inputs)
	return en_tools_microsoft_calendar_read_error(inputs)
});
export { tools_microsoft_calendar_read_error as "tools.microsoft_calendar.read_error" }